export default __webpack_public_path__ + "static/media/for_way4.451bd908.png";